import { AppAssets } from "../../../utils/consts/app_assets"

const PrivacyPolicyConst = {
  image:AppAssets.Error404.Error,
  title:'Oops!!  Page Not Found - Error 404',
  subtitle:'The page you are looking for might have been removed, had its name changed or its temporarily unavailable.'    
}

export default PrivacyPolicyConst